import { render } from "./vehicle-details.vue?vue&type=template&id=5ea8e402&scoped=true"
import script from "./vehicle-details.vue?vue&type=script&lang=js"
export * from "./vehicle-details.vue?vue&type=script&lang=js"

import "./vehicle-details.vue?vue&type=style&index=0&id=5ea8e402&scoped=true&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea8e402"]])

export default __exports__